/**
 * Component controller for Tab Pane layouts
 */
export class TabPane {
    public static cssClass = 'tab-container';

    private container: HTMLElement;
    private contentContainer: HTMLElement;
    private tabBarEl: HTMLElement | null = null;

    private activeTab: number | null = null;

    constructor(container: HTMLElement) {
        this.container = container;
        this.initialize();
    }

    private initialize = (): void => {
        if (!this.container) return;

        this.tabBarEl = this.container.querySelector('.mdc-tab-bar');

        this.contentContainer = this.container.getElementsByClassName('tab-container__content')[0] as HTMLElement;
        if (!this.tabBarEl || !this.contentContainer) return;

        this.tabBarEl.addEventListener('change', (event: any) => {
            const tabIndex = event.detail?.index ?? 0;
            this.showContent(tabIndex);
        });

        // Default to the first tab being active
        this.setActiveTab(0);
        this.showContent(0);
    }

    /**
     * Switch to a tab by index
     */
    public setActiveTab = (tabIndex: number): void => {
        if (this.tabBarEl) {
            (this.tabBarEl as any).selected = tabIndex;
        }
    }

    private showContent = (tabIndex: number): void => {
        if (tabIndex !== this.activeTab && this.contentContainer) {
            for (let i = 0; i < this.contentContainer.children.length; i++) {
                const element = this.contentContainer.children[i] as HTMLElement;
                if (i === tabIndex) {
                    element.style.removeProperty('display');
                } else {
                    element.style.display = 'none';
                }
            }
            this.activeTab = tabIndex;
        }
    }
}
